import {
	BOOLEAN_LITERAL_FALSE,
	BOOLEAN_LITERAL_TRUE,
	isComplexOperatorRegex,
	isIdentifierRegex,
	isKeywordRegex,
	isLogicalOperatorRegex,
	isModifierRegex,
	isOperatorRegex,
	isWSRegex,
	LEFT_PARENTHESIS,
	NULL_LITERAL,
	RIGHT_PARENTHESIS,
	splitToTokensRegex,
} from './constants';
import { type Token } from './types';

const isIntegerString = (value: any): boolean => {
	const regExp = new RegExp(/^([-]{0,1}[0-9])*$/);
	return typeof value === 'string' && regExp.test(value);
};

export const tokenizer = (query: string): Token[] => {
	const items = query.split(splitToTokensRegex).filter(Boolean);

	return items.map((item) => {
		if (isWSRegex.test(item)) {
			return {
				type: 'WHITE_SPACE',
				value: item,
			};
		} else if (isLogicalOperatorRegex.test(item)) {
			return {
				type: 'LOGICAL_OPERATOR',
				value: item,
			};
		} else if (isComplexOperatorRegex.test(item)) {
			return {
				type: 'OPERATOR',
				value: item,
			};
		} else if (isOperatorRegex.test(item)) {
			return {
				type: 'OPERATOR',
				value: item,
			};
		} else if (item === LEFT_PARENTHESIS || item === RIGHT_PARENTHESIS) {
			return {
				type: 'SEPARATOR',
				value: item,
			};
		} else if (isIdentifierRegex.test(item)) {
			return {
				type: 'IDENTIFIER',
				value: item,
			};
		} else if (isModifierRegex.test(item)) {
			return {
				type: 'MODIFIER',
				value: item,
			};
		} else if (isKeywordRegex.test(item)) {
			return {
				type: 'KEYWORD',
				value: item,
			};
		} else if (item.toLowerCase() === NULL_LITERAL) {
			return {
				type: 'NULL_LITERAL',
				value: item,
			};
		} else if (isIntegerString(item)) {
			return {
				type: 'NUMBER_LITERAL',
				value: item,
			};
		} else if (
			item.toLowerCase() === BOOLEAN_LITERAL_TRUE ||
			item.toLowerCase() === BOOLEAN_LITERAL_FALSE
		) {
			return {
				type: 'BOOLEAN_LITERAL',
				value: item,
			};
		} else {
			return {
				type: 'STRING_LITERAL',
				value: item,
			};
		}
	});
};
